import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getAddressSuggestion} from '../../services/getAddressSuggestion';
import {UseGetAddressSuggestionQueryParams} from './types';

export const useGetAddressSuggestionQuery = ({
	enabled,
	beneficiaryCode,
}: UseGetAddressSuggestionQueryParams = {}) =>
	useQuery({
		queryKey: [QUERY_KEYS.ADDRESS_SUGGESTION, beneficiaryCode],
		queryFn: ({signal}) => getAddressSuggestion({signal}),
		enabled: !!beneficiaryCode && enabled,
	});
